import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import SEOHead from "@/components/seo/SEOHead";
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowLeft, Mail, Phone } from "lucide-react";
import { LocaleLink } from "@/components/LocaleLink";
import { useTranslation } from "react-i18next";

const RegistrierenDanke = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <SEOHead title={t("thankyou.registrationTitle")} canonical="/registrieren/danke" />
      <Header />

      <main id="main-content" className="flex-1 pt-28 pb-20 section-padding flex items-center">
        <div className="max-w-xl mx-auto text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-accent/10 mb-8">
            <CheckCircle className="w-10 h-10 text-accent" />
          </div>

          <h1 className="text-headline mb-4">{t("thankyou.registrationTitle")}</h1>
          <p className="text-caption text-lg mb-3">{t("thankyou.registrationDesc")}</p>

          <div className="border border-border bg-card p-6 mb-8 text-left space-y-3">
            <h2 className="text-body font-semibold">{t("thankyou.nextStepsTitle")}</h2>
            <ol className="list-decimal list-inside text-caption space-y-2">
              <li>{t("thankyou.registrationStep1")}</li>
              <li>{t("thankyou.registrationStep2")}</li>
              <li>{t("thankyou.registrationStep3")}</li>
            </ol>
            <p className="text-caption text-sm pt-2">{t("thankyou.reviewTime")}</p>
          </div>

          <p className="text-caption mb-10">
            {t("thankyou.urgentContact")}{" "}
            <a href="tel:+4921224355800" className="text-accent hover:underline inline-flex items-center gap-1">
              <Phone className="w-3.5 h-3.5" />
              0212 24355800
            </a>{" "}
            {t("thankyouExtra.orVia")}{" "}
            <a href="mailto:kontakt@craftfindus.de" className="text-accent hover:underline inline-flex items-center gap-1">
              <Mail className="w-3.5 h-3.5" />
              {t("thankyouExtra.emailLabel")}
            </a>.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild variant="commit" size="lg" className="gap-2">
              <LocaleLink to="/">
                <ArrowLeft className="w-4 h-4" />
                {t("common.backToHome")}
              </LocaleLink>
            </Button>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default RegistrierenDanke;
